import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

import CssBaseline from "@mui/material/CssBaseline";
import LeftMenu from "./LeftMenu";
import "./Layout.css";
import { IconButton } from "@mui/material";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import useIsSmallScreen from "../utils/useIsSmallScreen";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open, isSmallScreen }) => ({
    flexGrow: 1,
    minHeight: "100%",
    background: "#c9dfed",
    overflow: "auto",
    marginTop: isSmallScreen ? "50px" : 0,
  })
);

export default function Layout({ children }) {
  const IS_SMALL_SCREEN = useIsSmallScreen();
  const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(false);

  return (
    <Box
      sx={{ display: "flex", width: "100vw", height: "100vh" }}
      className="md-baseline"
    >
      <CssBaseline />
      {IS_SMALL_SCREEN ? (
        <>
          <IconButton
            onClick={() => setIsLeftMenuOpen(true)}
            className="md-openLeftMenu"
            sx={{
              position: "fixed",
              background: (theme) => theme.palette.primary.dark,
              width: "100%",
              height: "50px",
              borderRadius: "0",
              color: "#fff",
              zIndex: 999,
            }}
          >
            <AiOutlineMenuUnfold />
          </IconButton>
          <Box
            className={`smallScreen-left-menu-section ${
              isLeftMenuOpen ? "open" : "close"
            }`}
            sx={{ backgroundColor: (theme) => theme.palette.secondary.main }}
          >
            <LeftMenu
              closeLeftMenu={() => setIsLeftMenuOpen(false)}
              isSmallScreen={IS_SMALL_SCREEN}
              isOpen={isLeftMenuOpen}
            />
          </Box>
        </>
      ) : (
        <Box
          className="md-leftMenu-root"
          sx={{
            height: "100%",
          }}
        >
          <LeftMenu />
        </Box>
      )}
      <Main open={isLeftMenuOpen} isSmallScreen={IS_SMALL_SCREEN}>
        {children}
      </Main>
    </Box>
  );
}
